import React from 'react';
import Modal from 'react-modal';
import Row from '../tag/Row';
import OTButton from '../tag/OTButton';
import modal from '../../definitions/Modal';
import { FormattedMessage, injectIntl } from "react-intl";

const {id: module_id} = module;

const formErrorModal = modal({
    content: { width: '430px', padding: '20px 30px', marginLeft: '0', marginRight: '0'}
});

const FormErrorModal = (props) => {
    let {
        intl,
        isOpen,
        moduleId = module_id,
        closeModal
    } = props;

    return (
        <Modal
            isOpen={isOpen}
            shouldReturnFocusAfterClose={false}
            shouldFocusAfterRender
            shouldCloseOnEsc={true}
            onRequestClose={closeModal}
            shouldCloseOnOverlayClick={true}
            style={formErrorModal}
            contentLabel={intl.formatMessage({id:`${module_id}.contentLabel`})}
        >
            <div className="formula-error-modal-content">
                <Row className="formula-error-modal-content-row">
                    <span>
                    <FormattedMessage id={`${module_id}.content`} values={{br: <br />}}/>
                </span>
                </Row>
                <Row className="formula-error-modal-content-row">
                    <OTButton
                        message={intl.formatMessage({id: `${module_id}.confirm`})}
                        onClick={closeModal} />
                </Row>
            </div>
        </Modal>
    )

}

export default injectIntl(FormErrorModal);